module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("Many commit the same crime")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("with a very different result.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("One bears a cross for his")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("crime; another a crown.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("—Juvenal")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("I am unjust, but I can strive for justice.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("My life’s unkind, but I can vote for kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("I, the unloving, say life should be lovely.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("I, that am blind, cry out against my blindness.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("—Vachel Lindsay")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("I know that what I do is wrong, but my reasons for doing it are right.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("I hate blood and killing, but I hate the Mafia cancer even more.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("—Mack Bolan, "), _c('i', [_vm._v("The Executioner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9d3e606","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/dedication.vue
// module id = 81
// module chunks = 0